export const NO_ACCESS = 'NO ACCESS';
export const READ_ONLY = 'READ-ONLY';
export const FULL_ACCESS = 'FULL ACCESS';
export const SELECT_SCOPE_HEADER = 'Select scope access level';
export const DEVELOPERS_DOCUMENTATION_BASE_URL =
  'https://developers.thinkific.com/api/scopes/';
